import { DEFAULT_ALERT_CONFIG } from './configuration.defaults';
import { Organization } from '../contacts/user.service';

export function subjectLabels(org?: Pick<Organization, 'alertConfig'> | null): {
  singular: string;
  plural: string;
} {
  const singular = org?.alertConfig?.subjectLabel?.trim() || DEFAULT_ALERT_CONFIG.subjectLabel;
  const plural = org?.alertConfig?.subjectLabelPlural?.trim() || DEFAULT_ALERT_CONFIG.subjectLabelPlural;
  return { singular, plural };
}

/** Mid-sentence form of a subject label (Patient → patient). */
export function subjectWord(label: string): string {
  const trimmed = label.trim();
  if (!trimmed) {
    return DEFAULT_ALERT_CONFIG.subjectLabel.toLowerCase();
  }
  return trimmed.charAt(0).toLowerCase() + trimmed.slice(1);
}
